import LoadingIndicator from '@/widgets/LoadingIndicator'
import NoResultsIndicator from '@/widgets/NoResultsIndicator'

export default function SelectFilterModal({
	isOpen,
	onClose,
	searchTerm,
	setSearchTerm,
	items,
	loading,
	error,
	activeId,
	setActiveId,
	selectedName,
	clearFilter,
	onApply,
	title,
	description,
	placeholder,
	emptyMessage,
	emptyDescription = 'Sprobuj zmienic wyszukiwanie',
	labelAccessor = item => item?.nazwa || '-',
	applyLabel = 'Zastosuj',
	clearLabel = 'Wyczysc filtr',
	zIndexClass = 'z-50',
}) {
	if (!isOpen) return null

	return (
		<div className={`fixed inset-0 ${zIndexClass} flex items-center justify-center p-4`}>
			<div className="absolute inset-0 bg-black/40" onClick={onClose} />
			<div className="relative w-full max-w-xl rounded-lg bg-white shadow-xl">
				<div className="border-b border-gray-200 p-4">
					<h3 className="text-base font-semibold text-gray-900">{title}</h3>
					<p className="mt-1 text-sm text-gray-500">{description}</p>
				</div>
				<div className="p-4">
					<input
						type="text"
						value={searchTerm}
						onChange={e => setSearchTerm(e.target.value)}
						placeholder={placeholder}
						className="w-full rounded border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
						autoFocus
					/>
					<div className="mt-3 max-h-72 overflow-y-auto rounded border border-gray-200">
						{loading ? (
							<div className="p-4">
								<LoadingIndicator />
							</div>
						) : error ? (
							<div className="p-4 text-sm text-red-600">{error}</div>
						) : items.length === 0 ? (
							<div className="p-4">
								<NoResultsIndicator message={emptyMessage} description={emptyDescription} />
							</div>
						) : (
							<ul className="divide-y divide-gray-100">
								{items.map(item => {
									const id = item?._id || item?.id
									const isActive = id === activeId
									return (
										<li key={id || labelAccessor(item)}>
											<button
												type="button"
												onClick={() => setActiveId(id)}
												className={`w-full px-3 py-2 text-left text-sm ${
													isActive ? 'bg-blue-50 text-blue-700 font-medium' : 'hover:bg-gray-50 text-gray-700'
												}`}>
												{labelAccessor(item)}
											</button>
										</li>
									)
								})}
							</ul>
						)}
					</div>
					{activeId && (
						<p className="mt-2 text-xs text-gray-500">
							Wybrane: <span className="font-medium text-gray-700">{selectedName || activeId}</span>
						</p>
					)}
				</div>
				<div className="flex justify-between border-t border-gray-200 p-4">
					<button
						type="button"
						onClick={() => {
							clearFilter()
							onApply(null, '')
						}}
						className="rounded-md border border-gray-300 bg-white px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50">
						{clearLabel}
					</button>
					<div className="flex gap-2">
						<button
							type="button"
							onClick={onClose}
							className="rounded-md border border-gray-300 bg-white px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50">
							Anuluj
						</button>
						<button
							type="button"
							onClick={() => onApply(activeId || null, selectedName)}
							className="rounded-md bg-indigo-600 px-3 py-2 text-sm font-medium text-white hover:bg-indigo-500">
							{applyLabel}
						</button>
					</div>
				</div>
			</div>
		</div>
	)
}
